const AuthHelpers = {
    // Obtiene el CSRF token desde las cookies
    getCsrfToken: () => {
        return document.cookie
            .split('; ')
            .find(row => row.startsWith('csrftoken='))?.split('=')[1] || null;
    },

    // Realiza peticiones fetch con CSRF token incluido
    fetchWithCSRF: async (url, options = {}) => {
        const headers = new Headers(options.headers || {});

        // Solo establecer Content-Type si no es FormData
        // FormData necesita que el navegador establezca el Content-Type automáticamente con el boundary
        if (!(options.body instanceof FormData)) {
            headers.set('Content-Type', 'application/json');
        }

        const csrfToken = AuthHelpers.getCsrfToken();
        if (csrfToken) {
            headers.set('X-CSRFToken', csrfToken);
        }

        return fetch(url, {
            ...options,
            headers,
            credentials: 'include',  // 👈 importante para que Django reciba la sesión
        });
    },

    // Cierra sesión y redirige
    logout: async () => {
        const csrfToken = AuthHelpers.getCsrfToken();

        try {
            await fetch('/logout/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken || '',
                },
                credentials: 'include',
            });
        } catch (e) {
            console.error('Error al cerrar sesión:', e);
        }

        window.location.href = '/login';
    }
};

export default AuthHelpers;
